import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    isLayoutMobile?: boolean;
  }>()
  .create(({ theme, isLayoutMobile }) => ({
    vulnerabilityDetails: {
      display: 'flex',
      flexDirection: isLayoutMobile ? 'column' : 'row',
      [theme.breakpoints.down('xl')]: {
        flexDirection: 'column'
      }
    },
    // left column
    vulnerabilityDetailsColumnLeft: {
      flex: 1,
      position: 'relative',
      paddingRight: isLayoutMobile ? 0 : theme.spacing(3),
      '& > *': {
        marginBottom: theme.spacing(3)
      },
      [theme.breakpoints.down('xl')]: {
        paddingRight: 0
      }
    },
    // right column
    vulnerabilityDetailsColumnRight: {
      width: '20vw',
      display: 'flex',
      minWidth: '500px',
      [theme.breakpoints.up('xxl')]: {
        width: '500px'
      },
      [theme.breakpoints.down('xl')]: {
        width: '100%',
        flexDirection: 'row'
      },
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column'
      },
      [theme.breakpoints.down('md')]: {
        minWidth: 'auto'
      }
    },
    vulnerabilityDetailsColumnRightItem: {
      height: 'auto',
      [theme.breakpoints.down('xl')]: {
        marginBottom: theme.spacing(3),
        width: '100%'
      }
    },
    cardHeader: {
      borderBottom: `1px solid ${theme.vars.palette.divider}`,
      flexShrink: 0
    }
  }));

export default useStyles;
